/* Diagnostic olfactif Ambre & Musc — moteur de flow + matching (V1 parfum-only).
 * Charte : vouvoiement, zéro emoji, zéro em dash. Matching déterministe, zéro IA.
 * Catalogue : assets/am-diag-catalog.json (buildé par scripts/build-catalog-parfums.mjs).
 * Capture email : POST vers window.AM_DIAG.endpoint (Worker Cloudflare → Klaviyo server-side).
 */
(function () {
  'use strict';
  var CFG = window.AM_DIAG || {};
  var ROOT = document.getElementById('am-diagnostic');
  if (!ROOT) return;

  // ---------- Données de référence ----------
  var FAMILLES = ['Hespéridé', 'Floral', 'Fougère', 'Chypre', 'Boisé', 'Ambre / Oriental', 'Cuir', 'Gourmand', 'Aromatique', 'Musc', 'Vert', 'Aquatique', 'Épice'];
  var FAMILLE_DESC = {
    'Hespéridé': 'agrumes, bergamote, fraîcheur', 'Floral': 'rose, jasmin, fleur d\'oranger', 'Fougère': 'lavande, sauge, herbacé',
    'Chypre': 'mousse, patchouli, élégance', 'Boisé': 'cèdre, vétiver, santal', 'Ambre / Oriental': 'résines chaudes, vanille, épices',
    'Cuir': 'cuir, tabac, fumé', 'Gourmand': 'vanille, caramel, cacao', 'Aromatique': 'thym, romarin, frais',
    'Musc': 'peau, propre, cocon', 'Vert': 'feuilles, galbanum, végétal', 'Aquatique': 'iode, embruns, minéral', 'Épice': 'poivre, cardamome, safran'
  };
  var FAMILLE_VOISINES = {
    'Fougère': ['Aromatique', 'Boisé'], 'Vert': ['Aromatique', 'Hespéridé'], 'Cuir': ['Boisé', 'Ambre / Oriental'],
    'Aquatique': ['Hespéridé', 'Vert'], 'Épice': ['Ambre / Oriental', 'Boisé'], 'Chypre': ['Boisé', 'Floral'],
    'Gourmand': ['Ambre / Oriental', 'Floral'], 'Musc': ['Floral', 'Boisé'], 'Aromatique': ['Fougère', 'Hespéridé'],
    'Hespéridé': ['Aromatique', 'Aquatique'], 'Floral': ['Chypre', 'Musc'], 'Boisé': ['Ambre / Oriental', 'Cuir'],
    'Ambre / Oriental': ['Boisé', 'Épice']
  };
  var INTENSITE = {
    seconde_peau: { label: 'Discret, comme une seconde peau', conc: ['Eau de Cologne', 'Eau de Toilette'], sil: ['Intime', 'Modéré'], ten: ['Légère', 'Modérée'] },
    elegant: { label: 'Élégant et présent, sans en faire trop', conc: ['Eau de Toilette', 'Eau de Parfum'], sil: ['Modéré', 'Généreux'], ten: ['Modérée', 'Longue tenue'] },
    affirme: { label: 'Affirmé, je veux qu\'on le remarque', conc: ['Eau de Parfum', 'Extrait'], sil: ['Généreux', 'Puissant'], ten: ['Longue tenue', 'Très longue tenue'] },
    puissant: { label: 'Puissant, sillage long, signature assumée', conc: ['Extrait', 'Eau de Parfum'], sil: ['Puissant', 'Généreux'], ten: ['Très longue tenue', 'Longue tenue'] }
  };
  var USAGE = [
    { key: 'signature', label: 'Tous les jours, mon parfum signature', occ: ['Quotidien'], mom: [] },
    { key: 'soir', label: 'Le soir, les occasions, la séduction', occ: ['Soirée', 'Rendez-vous'], mom: ['Soir'] },
    { key: 'bureau', label: 'Le bureau, discret et propre', occ: ['Bureau'], mom: ['Jour'] },
    { key: 'cadeau', label: 'Un cadeau', occ: [], mom: [] },
    { key: 'curieux', label: 'Élargir ma collection, je suis curieux', occ: [], mom: [] }
  ];

  // ---------- État ----------
  var STORE_KEY = 'am_diag_v1';
  var state = loadState() || { step: 0, debutant: null, loved: [], familles: [], intensite: null, usage: [], email: '', cp: '', consent: false };
  var CATALOG = [];
  var byHandle = {};

  function loadState() { try { var s = JSON.parse(localStorage.getItem(STORE_KEY)); if (s && s._t && (Date.now() - s._t) < 864e5) return s; } catch (e) {} return null; }
  function saveState() { try { state._t = Date.now(); localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {} }
  function resetState() { state = { step: 0, debutant: null, loved: [], familles: [], intensite: null, usage: [], email: '', cp: '', consent: false }; try { localStorage.removeItem(STORE_KEY); } catch (e) {} }

  // ---------- Matching (porté de diagnostic-match.mjs) ----------
  function slug(s) { return (s || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim().replace(/\s+/g, '-'); }
  function baseName(t) { return slug((t || '').replace(/\b(eau de parfum|eau de toilette|extrait de parfum|extrait|edp|edt|eau de cologne)\b/gi, '')).replace(/-+$/, ''); }
  function jaccard(setA, arrB) { if (!setA.size || !arrB.length) return 0; var B = {}, inter = 0; arrB.forEach(function (x) { B[x] = 1; }); setA.forEach(function (x) { if (B[x]) inter++; }); return inter / (setA.size + arrB.length - inter); }

  function buildProfile() {
    var fam = {}, notes = new Set();
    state.loved.forEach(function (h) { var p = byHandle[h]; if (!p) return; if (p.famille) fam[p.famille] = (fam[p.famille] || 0) + 1.0; (p.notes_slugs || []).forEach(function (s) { notes.add(s); }); });
    state.familles.forEach(function (f) { fam[f] = (fam[f] || 0) + 2.0; (FAMILLE_VOISINES[f] || []).forEach(function (v) { fam[v] = (fam[v] || 0) + 0.5; }); });
    var occ = new Set(), mom = new Set();
    state.usage.forEach(function (k) { var u = USAGE.find(function (x) { return x.key === k; }); if (u) { u.occ.forEach(function (o) { occ.add(o); }); u.mom.forEach(function (m) { mom.add(m); }); } });
    return { fam: fam, notes: notes, occ: occ, mom: mom };
  }
  function scoreOne(p, prof) {
    var maxFam = 1; for (var k in prof.fam) if (prof.fam[k] > maxFam) maxFam = prof.fam[k];
    var sFam = (prof.fam[p.famille] || 0) / maxFam;
    var sNotes = jaccard(prof.notes, p.notes_slugs || []);
    var sInt = 0, t = INTENSITE[state.intensite];
    if (t) { var h = 0; if (t.conc.indexOf(p.concentration) > -1) h++; if (t.sil.indexOf(p.sillage) > -1) h++; if (t.ten.indexOf(p.tenue) > -1) h++; sInt = h / 3; }
    var wanted = []; prof.occ.forEach(function (x) { wanted.push(x); }); prof.mom.forEach(function (x) { wanted.push(x); });
    var us = new Set((p.occasion || []).concat(p.moment || []));
    var sUse = wanted.length ? wanted.filter(function (x) { return us.has(x); }).length / wanted.length : 0;
    return { total: 5 * sFam + 3 * sNotes + 2 * sInt + 1 * sUse, sFam: sFam, sNotes: sNotes };
  }
  function recommend(n) {
    n = n || 5;
    var prof = buildProfile();
    var lovedBase = {}; state.loved.forEach(function (h) { if (byHandle[h]) lovedBase[baseName(byHandle[h].title)] = 1; });
    var pool = CATALOG.filter(function (p) { return p.available && p.famille && !lovedBase[baseName(p.title)]; });
    var scored = pool.map(function (p) { var s = scoreOne(p, prof); return { p: p, total: s.total, sFam: s.sFam, sNotes: s.sNotes }; }).sort(function (a, b) { return b.total - a.total; });
    var out = [], famCount = {};
    for (var i = 0; i < scored.length && out.length < n; i++) { var f = scored[i].p.famille; if ((famCount[f] || 0) >= 2) continue; famCount[f] = (famCount[f] || 0) + 1; out.push(scored[i]); }
    var max = out[0] ? out[0].total : 1;
    out.forEach(function (s) { s.match = Math.max(78, Math.round(100 * s.total / max)); });
    return out;
  }
  function whyText(s) {
    var p = s.p, lovedNotes = [];
    state.loved.forEach(function (h) { if (byHandle[h]) (byHandle[h].notes_slugs || []).forEach(function (x) { lovedNotes.push(x); }); });
    var shared = (p.notes.tete || []).concat(p.notes.coeur || [], p.notes.fond || []).find(function (nn) { return lovedNotes.indexOf(nn.slug) > -1; });
    if (shared && state.loved.length) return 'Proche de votre ' + byHandle[state.loved[0]].title + ', partage la note ' + shared.nom;
    if (s.sFam >= 0.9) return 'Cœur ' + p.famille.toLowerCase() + ', exactement votre matière';
    return p.famille + (p.caractere && p.caractere[0] ? ', ' + p.caractere[0].toLowerCase() : '');
  }

  // ---------- Portrait (synthèse) ----------
  function portrait() {
    var prof = buildProfile();
    var fams = Object.keys(prof.fam).sort(function (a, b) { return prof.fam[b] - prof.fam[a]; });
    var dom = fams[0] || (state.familles[0]) || null, sec = fams[1] || null;
    // pyramide : notes des parfums aimés, sinon notes des top recos
    var src = state.loved.map(function (h) { return byHandle[h]; }).filter(Boolean);
    if (!src.length) src = recommend(3).map(function (s) { return s.p; });
    function collect(level) { var seen = {}, out = []; src.forEach(function (p) { (p.notes[level] || []).forEach(function (nn) { if (!seen[nn.slug]) { seen[nn.slug] = 1; out.push(nn.nom); } }); }); return out.slice(0, 5); }
    return { dom: dom, sec: sec, tete: collect('tete'), coeur: collect('coeur'), fond: collect('fond'), intensite: state.intensite ? INTENSITE[state.intensite].label : null };
  }

  // ---------- Saisie hybride marque -> parfum ----------
  var BRANDS = [];
  function buildBrandIndex() {
    var m = {};
    CATALOG.forEach(function (p) { var b = p.brand || 'Autre'; (m[b] = m[b] || []).push(p); });
    if (window.AM_DIAG_MAINSTREAM) window.AM_DIAG_MAINSTREAM.forEach(function (p) { var b = p.brand || 'Autre'; (m[b] = m[b] || []).push({ handle: '_ext_' + slug(p.brand + '-' + p.nom), title: p.nom, brand: p.brand, famille: p.famille, notes_slugs: (p.notes || []).map(slug), notes: { tete: [], coeur: [], fond: [] }, _external: true }); });
    BRANDS = Object.keys(m).sort();
    window._AM_BRANDMAP = m;
  }

  // ---------- Rendu des écrans ----------
  var STAGE = ROOT.querySelector('.amd-stage');
  var BAR = ROOT.querySelector('.amd-bar > span');
  var STEPS_VISIBLE = 8;
  function setBar() { if (BAR) BAR.style.width = Math.round(100 * (state.step) / (STEPS_VISIBLE - 1)) + '%'; }
  function go(step) { state.step = step; saveState(); render(); window.scrollTo({ top: ROOT.offsetTop - 20, behavior: 'smooth' }); }
  function next() { var n = state.step + 1; if (n === 1 && state.debutant) n = 2; go(n); }       // le néophyte saute la saisie parfums
  function back() { var n = state.step - 1; if (n === 1 && state.debutant) n = 0; go(Math.max(0, n)); }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function render() {
    setBar();
    var s = state.step;
    if (s === 0) return renderIntro();
    if (s === 1) return renderLoved();
    if (s === 2) return renderFamilles();
    if (s === 3) return renderIntensite();
    if (s === 4) return renderUsage();
    if (s === 5) return renderPortrait();
    if (s === 6) return renderEmail();
    if (s === 7) return renderResult();
  }

  function screen(html) { STAGE.innerHTML = '<div class="amd-screen">' + html + '</div>'; }
  function navBtns(opts) {
    opts = opts || {};
    var b = '<div class="amd-nav">';
    if (opts.back !== false) b += '<button class="amd-btn amd-btn--ghost" data-act="back">Retour</button>';
    if (opts.next) b += '<button class="amd-btn" data-act="next"' + (opts.nextDisabled ? ' disabled' : '') + '>' + opts.next + '</button>';
    return b + '</div>';
  }

  function renderIntro() {
    screen(
      '<p class="amd-kicker">Diagnostic olfactif</p>' +
      '<h2 class="amd-h">Trouvez votre signature</h2>' +
      '<p class="amd-sub">Cinq questions, deux minutes. On part de ce que vous aimez déjà, pas d\'un questionnaire abstrait. À la fin, votre sélection personnelle et un coffret de cinq échantillons à tester chez vous, dont le montant est crédité sur votre premier flacon.</p>' +
      '<div class="amd-choices amd-choices--2">' +
      '<button class="amd-card" data-act="start" data-deb="0"><strong>J\'ai des parfums que j\'aime</strong><span>On part de vos références</span></button>' +
      '<button class="amd-card" data-act="start" data-deb="1"><strong>Je débute</strong><span>Guidez-moi par familles</span></button>' +
      '</div>'
    );
  }

  function renderLoved() {
    var html = '<h2 class="amd-h">Un parfum que vous adorez ?</h2>' +
      '<p class="amd-sub">Citez jusqu\'à trois parfums que vous portez ou que vous aimez. Peu importe la marque, c\'est notre meilleur point de départ.</p>' +
      '<div class="amd-loved">';
    for (var i = 0; i < 3; i++) {
      var sel = state.loved[i] || '';
      html += '<div class="amd-loved-row">' +
        '<select class="amd-brand" data-i="' + i + '"><option value="">Marque</option>' + BRANDS.map(function (b) { return '<option>' + esc(b) + '</option>'; }).join('') + '</select>' +
        '<select class="amd-perf" data-i="' + i + '" disabled><option value="">Parfum</option></select>' +
        '</div>';
    }
    html += '</div>' + navBtns({ next: 'Découvrir mon diagnostic' });
    screen(html);
    // restaurer sélections
    state.loved.forEach(function (h, i) { var p = byHandle[h] || (h.indexOf('_ext_') === 0 ? { brand: '', title: '' } : null); });
    syncPerfSelects();
  }
  function syncPerfSelects() {
    ROOT.querySelectorAll('.amd-brand').forEach(function (bs) {
      var i = bs.getAttribute('data-i');
      var ps = ROOT.querySelector('.amd-perf[data-i="' + i + '"]');
      bs.onchange = function () {
        var list = (window._AM_BRANDMAP[bs.value] || []);
        ps.innerHTML = '<option value="">Parfum</option>' + list.map(function (p) { return '<option value="' + esc(p.handle) + '">' + esc(p.title) + '</option>'; }).join('');
        ps.disabled = !bs.value;
      };
      ps.onchange = function () { collectLoved(); };
    });
  }
  function collectLoved() {
    var arr = [];
    ROOT.querySelectorAll('.amd-perf').forEach(function (ps) { if (ps.value) arr.push(ps.value); });
    state.loved = arr; saveState();
  }

  function renderFamilles() {
    var html = '<h2 class="amd-h">Vers quelle matière allez-vous d\'instinct ?</h2>' +
      '<p class="amd-sub">Choisissez-en une ou deux. C\'est ce qui oriente la famille de votre signature.</p><div class="amd-grid">';
    FAMILLES.forEach(function (f) {
      var on = state.familles.indexOf(f) > -1;
      html += '<button class="amd-chip' + (on ? ' is-on' : '') + '" data-fam="' + esc(f) + '"><strong>' + esc(f) + '</strong><span>' + esc(FAMILLE_DESC[f] || '') + '</span></button>';
    });
    html += '</div>' + navBtns({ next: 'Continuer', nextDisabled: state.familles.length === 0 });
    screen(html);
  }

  function renderIntensite() {
    var html = '<h2 class="amd-h">Comment voulez-vous qu\'il se pose sur vous ?</h2><p class="amd-sub">Il n\'y a pas de bonne réponse, juste la vôtre.</p><div class="amd-choices">';
    Object.keys(INTENSITE).forEach(function (k) {
      html += '<button class="amd-card amd-card--row' + (state.intensite === k ? ' is-on' : '') + '" data-int="' + k + '"><strong>' + esc(INTENSITE[k].label) + '</strong></button>';
    });
    html += '</div>' + navBtns({ back: true });
    screen(html);
  }

  function renderUsage() {
    var html = '<h2 class="amd-h">Pour quoi, pour quand ?</h2><p class="amd-sub">Dernière question avant votre portrait. Plusieurs choix possibles.</p><div class="amd-choices">';
    USAGE.forEach(function (u) {
      var on = state.usage.indexOf(u.key) > -1;
      html += '<button class="amd-card amd-card--row' + (on ? ' is-on' : '') + '" data-use="' + u.key + '"><strong>' + esc(u.label) + '</strong></button>';
    });
    html += '</div>' + navBtns({ next: 'Voir mon portrait', nextDisabled: state.usage.length === 0 });
    screen(html);
  }

  function renderPortrait() {
    var pt = portrait();
    function pyr(label, arr) { return '<div class="amd-pyr-row"><span class="amd-pyr-l">' + label + '</span><span class="amd-pyr-n">' + (arr.length ? arr.map(esc).join(' · ') : 'à découvrir') + '</span></div>'; }
    screen(
      '<p class="amd-kicker">Votre portrait olfactif</p>' +
      '<h2 class="amd-h">' + esc(pt.dom || 'Signature') + (pt.sec ? ' <span class="amd-accent">· accent ' + esc(pt.sec) + '</span>' : '') + '</h2>' +
      (pt.intensite ? '<p class="amd-sub">' + esc(pt.intensite) + '</p>' : '') +
      '<div class="amd-pyramid">' + pyr('Tête', pt.tete) + pyr('Cœur', pt.coeur) + pyr('Fond', pt.fond) + '</div>' +
      '<p class="amd-note">Le diagnostic en ligne vous donne votre signature. L\'institut vous donne le résultat.</p>' +
      navBtns({ next: 'Découvrir mes parfums' })
    );
  }

  function renderEmail() {
    screen(
      '<h2 class="amd-h">Votre sélection est prête</h2>' +
      '<p class="amd-sub">Indiquez votre email : on y associe votre signature, vos cinq parfums recommandés et votre code pour le coffret découverte crédité. Le conseil d\'une parfumerie de niche, pas d\'une parfumerie de masse.</p>' +
      '<form class="amd-form" id="amd-form">' +
      '<input type="email" id="amd-email" required placeholder="Votre email" value="' + esc(state.email) + '">' +
      '<input type="text" id="amd-cp" inputmode="numeric" maxlength="5" placeholder="Code postal (pour savoir si vous pouvez les sentir en boutique)" value="' + esc(state.cp) + '">' +
      '<label class="amd-consent"><input type="checkbox" id="amd-consent"' + (state.consent ? ' checked' : '') + '> Je souhaite recevoir mes recommandations et les conseils d\'Ambre & Musc. Désinscription à tout moment.</label>' +
      '<button class="amd-btn amd-btn--full" type="submit">Recevoir mon diagnostic</button>' +
      '<button class="amd-btn amd-btn--ghost amd-btn--full" type="button" data-act="skip">Voir d\'abord mes résultats à l\'écran</button>' +
      '</form>' + navBtns({ next: false, back: true })
    );
  }

  function renderResult() {
    var recos = recommend(5);
    var pt = portrait();
    var seuil = CFG.coffret_seuil || 90, prix = CFG.coffret_prix || 15;
    var local = /^(92100|92210|92130|92150|92800|75015|75016)$/.test(state.cp);
    var cards = recos.map(function (s, i) {
      var p = s.p;
      return '<article class="amd-reco">' +
        (p.image ? '<div class="amd-reco-img"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"></div>' : '') +
        '<div class="amd-reco-body">' +
        '<span class="amd-reco-match">' + s.match + '% compatible</span>' +
        '<p class="amd-reco-brand">' + esc(p.brand || '') + '</p>' +
        '<h3 class="amd-reco-name">' + esc(p.title) + '</h3>' +
        '<p class="amd-reco-fam">' + esc(p.famille) + (p.concentration ? ' · ' + esc(p.concentration) : '') + '</p>' +
        '<p class="amd-reco-why">' + esc(whyText(s)) + '</p>' +
        '<div class="amd-reco-actions"><span class="amd-reco-price">' + (p.price ? p.price + ' €' : '') + '</span>' +
        '<button class="amd-btn amd-btn--sm" data-add="' + esc(p.handle) + '">Ajouter</button></div>' +
        '<a class="amd-reco-link" href="' + esc(p.url) + '">Voir la fiche</a>' +
        '</div></article>';
    }).join('');
    screen(
      '<p class="amd-kicker">Votre signature : ' + esc(pt.dom || '') + (pt.sec ? ' · accent ' + esc(pt.sec) : '') + '</p>' +
      '<h2 class="amd-h">Vos cinq parfums</h2>' +
      '<div class="amd-coffret"><div><strong>Testez vos 5 chez vous.</strong> Coffret ' + prix + ' €, intégralement crédités sur votre premier flacon dès ' + seuil + ' €. Blotter et carte pyramide inclus.</div>' +
      '<button class="amd-btn" data-act="coffret">Commander le coffret découverte</button></div>' +
      '<div class="amd-recos">' + cards + '</div>' +
      (local
        ? '<div class="amd-bridge"><strong>Sentez-les pour de vrai.</strong> RDV conseil gratuit avec Yamina, ou click and collect en 2h à Boulogne. <a href="/pages/institut-beaute-boulogne-billancourt">Prendre rendez-vous</a></div>'
        : '<div class="amd-bridge">Livraison offerte dès 100 €. De passage à Paris ? Venez les sentir à Boulogne. <a href="/pages/institut-beaute-boulogne-billancourt">Notre institut</a></div>') +
      '<button class="amd-btn amd-btn--ghost amd-btn--full" data-act="restart">Recommencer le diagnostic</button>'
    );
  }

  // ---------- Capture (Worker -> Klaviyo) ----------
  function submitDiagnostic(cb) {
    var pt = portrait(), recos = recommend(5);
    var payload = {
      email: state.email, code_postal: state.cp, consent_marketing: state.consent,
      diagnostic_type: 'parfum_v1', perfumes_loved: state.loved.map(function (h) { return byHandle[h] ? byHandle[h].title : h; }),
      familles: state.familles, famille_dominante: pt.dom, famille_secondaire: pt.sec,
      intensite: state.intensite, usage: state.usage,
      reco_handles: recos.map(function (s) { return s.p.handle; }), reco_n1: recos[0] ? recos[0].p.title : null,
      source: 'quiz_diagnostic_olfactif'
    };
    if (!CFG.endpoint) { console.warn('[AM_DIAG] endpoint non configuré, payload:', payload); return cb && cb(true); }
    fetch(CFG.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { cb && cb(r.ok); }).catch(function () { cb && cb(false); });
  }

  // ---------- AJAX cart ----------
  function addToCart(handle, btn) {
    if (handle.indexOf('_ext_') === 0) return;
    btn.disabled = true; btn.textContent = '...';
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      var v = (prod.variants || []).find(function (x) { return x.available; }) || prod.variants[0];
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) });
    }).then(function () { btn.textContent = 'Ajouté'; document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Réessayer'; });
  }

  // ---------- Délégation d'événements ----------
  ROOT.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act],[data-deb],[data-fam],[data-int],[data-use],[data-add]');
    if (!t) return;
    if (t.hasAttribute('data-deb')) { state.debutant = t.getAttribute('data-deb') === '1'; state.loved = []; saveState(); return next(); }
    var act = t.getAttribute('data-act');
    if (act === 'back') return back();
    if (act === 'next') return next();
    if (act === 'skip') { state.email = ''; state.consent = false; saveState(); return go(7); }
    if (act === 'restart') { resetState(); return render(); }
    if (act === 'coffret') { var h = CFG.coffret_handle; if (h) addToCart(h, t); else window.location = '/products/' + (CFG.coffret_handle || 'coffret-decouverte'); return; }
    if (t.hasAttribute('data-fam')) { var f = t.getAttribute('data-fam'), idx = state.familles.indexOf(f); if (idx > -1) state.familles.splice(idx, 1); else if (state.familles.length < 2) state.familles.push(f); saveState(); return renderFamilles(); }
    if (t.hasAttribute('data-int')) { state.intensite = t.getAttribute('data-int'); saveState(); return next(); }
    if (t.hasAttribute('data-use')) { var u = t.getAttribute('data-use'), j = state.usage.indexOf(u); if (j > -1) state.usage.splice(j, 1); else state.usage.push(u); saveState(); return renderUsage(); }
    if (t.hasAttribute('data-add')) return addToCart(t.getAttribute('data-add'), t);
  });
  ROOT.addEventListener('submit', function (e) {
    if (e.target.id !== 'amd-form') return;
    e.preventDefault();
    state.email = (document.getElementById('amd-email').value || '').trim();
    state.cp = (document.getElementById('amd-cp').value || '').trim();
    state.consent = document.getElementById('amd-consent').checked;
    saveState();
    var btn = e.target.querySelector('button[type=submit]'); btn.disabled = true; btn.textContent = 'Envoi...';
    submitDiagnostic(function () { go(7); });
  });

  // ---------- Boot ----------
  function boot(catalog) {
    CATALOG = catalog || []; byHandle = {}; CATALOG.forEach(function (p) { byHandle[p.handle] = p; });
    buildBrandIndex();
    render();
  }
  var url = CFG.catalogUrl;
  if (window.AM_DIAG_CATALOG) boot(window.AM_DIAG_CATALOG.parfums || window.AM_DIAG_CATALOG);
  else if (url) fetch(url).then(function (r) { return r.json(); }).then(function (d) { boot(d.parfums || d); }).catch(function () { STAGE.innerHTML = '<p class="amd-sub">Le diagnostic est momentanément indisponible.</p>'; });
  else STAGE.innerHTML = '<p class="amd-sub">Catalogue non configuré.</p>';
})();
